export default {
  setLoading(state, value) {
    state.loading = value;
  },
  setSchools(state, value) {
    state.schools = value;
  },
  setError(state, value) {
    state.error = value;
  },
};
